export { default } from './Capcalera';
